export { default } from './Capcalera';
